import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const isExcelUploadSlice = createSlice({
    name: "isExcelUpload",
    initialState: { value: false },
    reducers: {
        updateIsExcelUpload: (state, action: PayloadAction<boolean>) => {
            state.value = action.payload;
        },
    },
});

export const { updateIsExcelUpload } = isExcelUploadSlice.actions;
export default isExcelUploadSlice.reducer;
